import { useParams } from "react-router-dom";
import { isTaskShelfSize } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { ShelfSizePage } from "./ShelfSizePage";

const ShelfSize = () => {
    const { id: marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];

    if (!currentTask || !isTaskShelfSize(currentTask)) return <NotFound />;

    return <ShelfSizePage marketId={safeMarketId} task={currentTask} />;
};

export default ShelfSize;
